import React, {  PropTypes } from 'react';
import { Field, Fields } from 'redux-form';
import BoundPeriodPicker from './BoundPeriodPicker';


const CalculatedRow = ({result: {
  unitsInMonths,
  rentDiscounted,
  productionPrice,
  setupPrice,
  tax,
  totalWoVat,
  discount,

  totalRent,
  totalTax,
  totalDiscount
}, subjects, disabledPeriods }) => (
  <tr>
    <td className="picker-cell">
      <div className="picker-container">
        <Fields names={['dateFrom', 'dateTo']} component={BoundPeriodPicker} props={{disabledDays: disabledPeriods }}/>
        <div className="months">{unitsInMonths} mēn.</div>
      </div>
    </td>
    <td className="subject-cell">
      <Field name="subject" component="select" className="form-control">
        <option value=''>Komercreklāma</option>
        {subjects.map(({id, label}) => <option key={id} value={id}>{label}</option>)}
      </Field>
    </td>
    <td className="text-sm-right">
      {totalRent}
      {parseFloat(totalDiscount) > 0 && <div className="discount">-{totalDiscount}</div>}
    </td>
    <td className="text-sm-right">{productionPrice}</td>
    <td className="text-sm-right">{setupPrice}</td>
    <td className="text-sm-right">{totalTax}</td>    
    <td className="text-sm-right">{totalWoVat}</td>
  </tr>
);

const InputRow = ({subjects, disabledPeriods}) => (
  <tr>
    <td className="picker-cell">
      <div className="picker-container">
        <Fields names={['dateFrom', 'dateTo']} component={BoundPeriodPicker} props={{disabledDays: disabledPeriods }}/>
      </div>
    </td>
    <td className="subject-cell">
      <Field name="subject" component="select" className="form-control">
        <option value=''>Komercreklāma</option>
        {subjects.map(({id, label}) => <option key={id} value={id}>{label}</option>)}
      </Field>
    </td>
    <td colSpan="5"/>
  </tr>
)


const Row = props => props.result? <CalculatedRow {...props} /> : <InputRow {...props} />

Row.propTypes = {
  result: PropTypes.object,
  subjects: PropTypes.array.isRequired,
  disabledPeriods: PropTypes.array.isRequired,
}

export default Row;


// WEBPACK FOOTER //
// ./src/containers/ProductBasket/Row.js